// extracted by mini-css-extract-plugin
module.exports = {"itemLink":"index_itemLink_gewF6","error":"index_error_1O_P_"};